<div class="bulk-drop" fxFlex="100" fxLayout="column">
    <div style="padding: 15px;">
        <div>
            <div class="dropzone" fileDragDrop (filesChangeEmitter)="onFileChange($event)">
                <div class="text-wrapper">
                    <div class="icon">
                        <i MatSuffix id="i1" class="flaticon-solid-upload"></i>
                    </div>
                    <div class="centered">
                        <input type="file" name="file" id="file" (change)="onFileChange($event)">
                        <label for="file">Select your files or simply drag & drop here!</label>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <button id="tgl" mat-raised-button (click)="toggle()">unclean data</button>
        <div id="unclean" class="unclean">
            <div class="title" fxLayout="row wrap">
                <div class="lgnd" id="unclean">
                    <div class="icon ">04</div>
                    <span>Unclean Data</span>
                </div>
                <div class="lgnd" id="Clean">
                    <div class="icon ">46</div>
                    <span>Clean Data</span>
                </div>
            </div>
            <app-editable-table></app-editable-table>
        </div>
        <div id="clean" class="clean">
            <div class="title">
                <p><strong>All the data provided is perfect.</strong></p>
            </div>

        </div>

    </div>

</div>